import { Navigate, Outlet } from 'react-router-dom';
import InitialLoading from '~/components/common/InitialLoading';
import { PAGE_ROUTE } from '~/constants';
import { useAuthStore } from '~/store';

export default function AuthRedirect() {
  const { isAuthenticated, isInitialized } = useAuthStore((state) => ({
    isAuthenticated: state.isAuthenticated,
    isInitialized: state.isInitialized,
  }));

  if (!isInitialized) {
    return <InitialLoading />;
  }

  if (isAuthenticated) {
    return <Navigate to={PAGE_ROUTE.MAIN} replace />;
  }

  return <Outlet />;
}
